import { useIdeActions } from '@common/ide/state';
import { ProjectDetail } from '@common/queries/project';
import { Entity } from '@common/types/Entity';
import { PipelineIcon, PlusIcon } from '@prophecy/icons';
import { theme } from '@prophecy/theme';
import { Centered, Stack, StackItem, Text, Button } from '@prophecy/ui-v3';
import styled from 'styled-components';

import { CanvasRootRootCls } from '../../layout/config';
import { ProjectLineageFooter } from './Footer';
import { Header } from './Header';

const StyledEmptyMessageSection = styled(Centered)`
  max-width: 325px;
  margin: 0 auto;
`;

const IconWrapperButton = styled(Button)`
  &:disabled {
    cursor: default;
    border-color: ${theme.colors.indigo200};
  }
` as unknown as typeof Button;
const StyledStackItem = styled(StackItem)`
  width: 100%;
  background: ${theme.colors.gray25};
`;

export function EmptyProject({ project }: { project: ProjectDetail }) {
  const ideActions = useIdeActions();

  return (
    <>
      <Stack className={CanvasRootRootCls}>
        <Header project={project} />
        <StyledStackItem grow='1' align='center'>
          <StyledEmptyMessageSection>
            <Stack alignY='center' gap={theme.spaces.x16}>
              <StackItem>
                <IconWrapperButton
                  variant='secondary'
                  size='xl'
                  disabled
                  icon={<PipelineIcon size='l' type='extended' color='#444CE7' />}
                  data-test-id='empty-project-pipeline-icon-button'
                  aria-label='Pipeline icon'
                />
              </StackItem>
              <StackItem>
                <Text level='md' tone={theme.colors.gray700}>
                  Start transforming your data by creating your first pipeline
                </Text>
              </StackItem>
              <Button
                variant='primary'
                icon={<PlusIcon type='solid' />}
                iconPlacement='left'
                onClick={() => ideActions.setEntityTypeToCreate(Entity.Pipeline)}
                data-test-id='empty-project-create-pipeline-button'>
                Create Pipeline
              </Button>
            </Stack>
          </StyledEmptyMessageSection>
        </StyledStackItem>
      </Stack>
      <ProjectLineageFooter projectId={project._id} />
    </>
  );
}
